import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "font-bold text-white bg-primary" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "User", -1)
const _hoisted_5 = {
  key: 0,
  class: "p-2"
}
const _hoisted_6 = { class: "p-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex justify-end gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Permissions", -1)
const _hoisted_10 = { class: "ml-5 list-disc" }

import { useFactionsStore } from '@/store/factions';
import { inject, onMounted, Ref, ref } from 'vue';
import { FactionMember, Rank } from '@/typings/user';
import Avatar from '@/components/User/Avatar.vue';
import GroupRoleBadge from '@/components/User/GroupRoleBadge.vue';
import DisplayName from '@/components/User/DisplayName.vue';
import Paginator from '@/components/UI/Paginator.vue';
import { apiFactions } from '@/api/faction';
import Modal from '@/components/Modal/Modal.vue';
import ToggleButtons from '@/components/Inputs/ToggleButtons.vue';
import { cloneDeep } from 'lodash';
import { useUserStore } from '@/store/users';
import { PromptModal } from '@/typings/modal';

interface Props {
  rank: Rank;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    rank: null
  },
  setup(__props: any) {

/* eslint-disable @typescript-eslint/no-non-null-assertion */


const store = useFactionsStore();
const { user } = useUserStore();
const members = ref<FactionMember[]>([]);

const pages = ref(0);
const page = ref(1);
const pageSize = ref(50);

function setPage(p: number) {
  page.value = p;
  fetchPages();
}

async function fetchPages() {
  const res = await apiFactions.getMembers(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    store.faction!.Uuid,
    pageSize.value,
    page.value - 1
  );

  members.value = res.data.records.filter((x) => x.Users.length === 1);
  pages.value = res.data.pageCount;
}

onMounted(fetchPages);

const roleModalVisible = ref(false);
const selectedMember = ref<FactionMember>();
const roleItems = [
  {
    value: Rank.member as number,
    text: 'Member',
    clickable: true,
  },
  {
    value: Rank.moderator as number,
    text: 'Moderator',
    clickable: true,
  },
  {
    value: Rank.admin as number,
    text: 'Admin',
    clickable: true,
  },
];

const roleDescriptors: Record<number, string[]> = {
  [Rank.member]: ['Can take part in leaderboards'],
  [Rank.moderator]: [
    'Can take part in leaderboards',
    'Can remove members from the faction (excluding the founder)',
  ],
  [Rank.admin]: [
    'Can take part in leaderboards',
    'Can remove members from the faction (excluding the founder)',
    'Can change members roles (excluding the founders)',
    'Can edit faction information',
  ],
};

function openRoleModal(member: FactionMember) {
  selectedMember.value = cloneDeep(member);
  roleModalVisible.value = true;
}

async function updateRole() {
  await apiFactions.putMemberRole(
    store.faction!.Uuid,
    selectedMember.value!.Users[0].Uuid,
    selectedMember.value!.Rank
  );
  roleModalVisible.value = false;
  fetchPages();
}

const promptModal = inject('promptModal') as Ref<PromptModal>;

async function removeUser(member: FactionMember) {
  const doDelete = await promptModal.value.show(
    `Are you sure?`,
    `You are about to remove ${member.Users[0].Name} from this faction. Are you sure?`
  );

  if (doDelete) {
    await apiFactions.deleteMember(store.faction!.Uuid, member.Users[0].Uuid);
    fetchPages();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", _hoisted_2, [
        _createElementVNode("tr", _hoisted_3, [
          _hoisted_4,
          (__props.rank !== _unref(Rank).member)
            ? (_openBlock(), _createElementBlock("th", _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (m) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: m.Users[0].Uuid
          }, [
            _createElementVNode("td", _hoisted_6, [
              _createVNode(DisplayName, {
                user: m.Users[0]
              }, {
                avatar: _withCtx(() => [
                  _createVNode(Avatar, null, {
                    default: _withCtx(() => [
                      (m.Rank !== _unref(Rank).member)
                        ? (_openBlock(), _createBlock(GroupRoleBadge, {
                            key: 0,
                            rank: m.Rank
                          }, null, 8, ["rank"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["user"])
            ]),
            (__props.rank !== _unref(Rank).member && m.Users[0].Uuid !== _unref(user)?.Uuid)
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (m.Rank !== _unref(Rank).owner && __props.rank !== _unref(Rank).moderator)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          onClick: ($event: any) => (openRoleModal(m))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_fa_icon, { icon: "pencil-ruler" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (m.Rank !== _unref(Rank).owner)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          onClick: ($event: any) => (removeUser(m))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_fa_icon, { icon: "ban" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(Paginator, {
      class: "my-5",
      "max-visible-buttons": 6,
      "total-pages": pages.value,
      "per-page": pageSize.value,
      "current-page": page.value,
      onPageChanged: setPage
    }, null, 8, ["total-pages", "per-page", "current-page"]),
    (roleModalVisible.value && selectedMember.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: "Update Role",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (roleModalVisible.value = false))
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "Update",
              onClick: updateRole
            }),
            _createVNode(_component_Button, {
              label: "Cancel",
              type: "secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (roleModalVisible.value = false))
            })
          ]),
          default: _withCtx(() => [
            _createVNode(ToggleButtons, {
              class: "flex items-center justify-center",
              items: roleItems,
              modelValue: selectedMember.value.Rank,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMember.value.Rank) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_9,
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleDescriptors[selectedMember.value.Rank], (descriptor, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(descriptor), 1))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})